import type { BoardingPass, CreatedPass } from '../types';
import { api } from './api';

export const boardingPassApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listBoardingPasses: builder.query<BoardingPass[], void>({
      query: () => `/templates/boarding_passes/`,
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'BoardingPasses' as const, id })),
              { type: 'BoardingPasses', id: 'LIST' },
            ]
          : [{ type: 'BoardingPasses', id: 'LIST' }],
    }),
    createBoardingPass: builder.mutation<BoardingPass, {}>({
      query: (data: object) => ({
        url: `/templates/boarding_passes/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: [{ type: 'BoardingPasses', id: 'LIST' }],
    }),
    retrieveBoardingPass: builder.query<BoardingPass, string>({
      query: (id) => `/templates/boarding_passes/${id}/`,
      providesTags: (result, error, id) => [{ type: 'BoardingPasses', id }],
    }),
    deleteBoardingPassTemplate: builder.mutation<BoardingPass, string>({
      query: (id) => ({
        url: `/templates/boarding_passes/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (res, err, id) => [{ type: 'BoardingPasses', id }, { type: 'BoardingPasses', id: 'LIST' }],
    }),
    patchBoardingPass: builder.mutation<BoardingPass, {id: string, updatedPassTemplate: object}>({
      query: (data) => ({
        url: `/templates/boarding_passes/${data.id}/`,
        method: 'PATCH',
        headers: {
          'content-type': 'application/json',
        },

        body: JSON.stringify(data.updatedPassTemplate),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'BoardingPasses', id: data.id }, { type: 'BoardingPasses', id: 'LIST' }],
    }),
    generateBoardingPass: builder.mutation<CreatedPass, {id: string, fieldsData: object}>({
      query: (data) => ({
        url: `/templates/boarding_passes/${data.id}/create_pass/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        invalidatesTags: ['BoardingPass',],
        body: JSON.stringify(data.fieldsData),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'BoardingPasses', id: data.id }, { type: 'BoardingPasses', id: 'LIST' }],
    }),
    updateBoardingPass: builder.mutation<CreatedPass, {id: string, fieldsData: object}>({
      query: (data) => ({
        url: `/templates/boarding_passes/${data.id}/update_pass/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        invalidatesTags: ['BoardingPass',],
        body: JSON.stringify(data.fieldsData),
      }),
      invalidatesTags: (res, err, data) => [{ type: 'BoardingPasses', id: data.id }, { type: 'BoardingPasses', id: 'LIST' }],
    }),
    deleteBoardingPass: builder.mutation<BoardingPass, {templateId: string, passId: string}>({
      query: (data) => ({
        url: `/templates/boarding_passes/${data.templateId}/delete_pass/`,
        method: 'DELETE',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({"pass_id": data.passId}),
      }),
      invalidatesTags: [{ type: 'BoardingPasses', id: 'LIST' }],
    }),
    sendBoardingPassPush: builder.mutation<BoardingPass, {templateId: string, passId: string, message: string}>({
      query: (data) => ({
        url: `/templates/boarding_passes/${data.templateId}/send_push/`,
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({"pass_id": data.passId, "message": data.message}),
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useListBoardingPassesQuery, useCreateBoardingPassMutation, useRetrieveBoardingPassQuery, useDeleteBoardingPassMutation, usePatchBoardingPassMutation,
  useGenerateBoardingPassMutation, useUpdateBoardingPassMutation, useSendBoardingPassPushMutation, useDeleteBoardingPassTemplateMutation } = boardingPassApi